import React, {useState, useEffect} from 'react';
import BaseMemberActivityPageComponent
  from '../../components/base/BaseMemberActivityPageComponent'
import AddEditNewsModal from './AddEditNewsModal';
import NewsCard from './NewsCard';
import {useLocation} from "react-router-dom"
import InlineEditBox from '../../components/base/InlineEditBox';
import BaseAddEditModal from '../../components/base/BaseAddEditModal';
import TableOperations from '../../components/base/utils/TableOperations';
import LineChart from './LineChart';
// /Users/szteam/Documents/work/抽奖后台管理/src/components/charts/LineChart.js

import {
  Box,
  Text,
  Card,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";

const NewsPage = (isOpen) => {

  const chartData = [{
    name: 'Play',
    data: [30, 40, 35, 50, 49, 60]
  }];

  const chartOptions = {
    chart: {
      id: 'basic-line',
      background: '#fff',      // 图表背景色
      toolbar: {show: true}  // 显示工具栏
    },
    colors: ['#3F51B5'],       // 线条颜色
    stroke: {
      curve: 'smooth',         // 平滑曲线
      width: 3                 // 线条宽度
    },
    markers: {
      size: 5,                 // 数据点大小
      colors: '#fff',          // 数据点颜色
      strokeWidth: 2,
      strokeColors: '#3F51B5'
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
      labels: {
        style: {
          colors: '#666',      // X轴标签颜色
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: '#666',      // Y轴标签颜色
          fontSize: '12px'
        }
      }
    },
    grid: {
      borderColor: '#f0f0f0'  // 网格线颜色
    }
  };

  const [primaryKey, setPrimaryKey] = useState("id");
  const tableName2 = 'game_record';

  const [gameOptions, setGameOptions] = useState([]);

  // 获取游戏选项
  const fetchGameOptions = async () => {
    try {
      const options = await TableOperations['game_select'].query()
      const formattedOptions = options.map(game => ({
        value: game.game_id,
        label: game.name
      }));
      setGameOptions(formattedOptions);

    } catch (error) {
      console.error("Error fetching game options:", error);
    }
  };

  useEffect(() => {
    fetchGameOptions();
  }, []);

  const keyMappings2 = {
    id: 'Id',
    identifier: 'Identifier',
    member_id: 'Member Id',
    prize_name: 'Lottery Results',
    created_at: 'Created At',
  };

  const tableHeaders2 = [
    'id',
    'identifier',
    'member_id',
    'prize_name',
    'created_at',
  ];

  return (
    <Box pt={{base: "130px", md: "80px", xl: "8px"}}>

      <Box
        p="20px"
        borderWidth="1px"
        borderRadius="lg"
        mb="20px"
        boxShadow="md"
        position="relative"
      >
        <div style={{width: '600px', height: '400px', padding: '20px'}}>
          <LineChart
            chartData={chartData}
            chartOptions={chartOptions}
          />
        </div>
        <Text fontSize="xl" fontWeight="bold" ml={2} mb={3}>Game Record</Text>
        <BaseMemberActivityPageComponent
          itemCardComponent={NewsCard}
          showToggleView={false}
          tableName={tableName2}
          tableHeaders={tableHeaders2}
          keyMappings={keyMappings2}
          showPagination={true}
          showSearch={true}
          searchPlaceholder="Search by ID/Member ID"
          searchFields="email"
          showAddIcon={false}
          primaryKey={primaryKey}
          showActions={false}
        />
      </Box>
    </Box>

  );
};

export default NewsPage;

